/*
 * Mega menú mobile — toggle de acordeones internos (versión definitiva).
 *
 * Contexto: el tema trae un manejador para estos chips en global-misc.js
 * ("Mega menu mobile toggle"), pero corre dentro de un DOMContentLoaded que
 * no siempre llega a dispararse (según cómo se cargue el archivo), y cuando
 * sí se engancha hace su toggle un frame después (requestAnimationFrame),
 * pisando cualquier otro manejador. Resultado: chips muertos o toggles que
 * se anulan entre sí.
 *
 * Solución: este script captura el click ANTES de que llegue al chip
 * (listener en fase de captura + stopPropagation), hace el toggle él mismo y
 * evita que cualquier otro manejador duplicado corra. Funciona igual si el
 * de global-misc.js está enganchado o no.
 *
 * Los ítems de nivel 1 (SALE / NIÑAS / NIÑOS / SHOP…) no se tocan: son links
 * que navegan a su colección (comportamiento original del tema).
 */
(function () {
  function isMobile() {
    return window.matchMedia('(max-width: 989px)').matches;
  }

  /* Si el panel activo del drawer llega con todos los acordeones cerrados
     (los bloques tienen "Show Default Menu on Mobile" desactivado), abre el
     "default" (etiqueta "Colección" / "Shop by product"). */
  function expandDefault() {
    if (!isMobile()) return;
    document.querySelectorAll('header-drawer .mega-menu__item.open').forEach(function (menuItem) {
      var subs = menuItem.querySelectorAll('.mega-menu__category-item-sub.hidden-pc');
      var target = null;
      for (var i = 0; i < subs.length; i++) {
        if (subs[i].classList.contains('is_active')) return; // ya hay uno abierto
        var btn = subs[i].querySelector('[data-transform-menu-mb]');
        if (!btn) continue;
        if (btn.getAttribute('data-submenu-id') === 'default' || !target) {
          target = subs[i];
        }
      }
      if (target) target.classList.add('is_active');
    });
  }

  /* Toggle de los chips — en CAPTURA, para correr antes que cualquier otro
     listener y frenar el evento (evita el doble toggle de global-misc.js). */
  document.addEventListener(
    'click',
    function (event) {
      if (!isMobile()) return;

      var subBtn = event.target.closest('header-drawer [data-transform-menu-mb]');
      if (subBtn) {
        event.preventDefault();
        event.stopPropagation();
        var subItem = subBtn.closest('.mega-menu__category-item-sub');
        if (subItem) subItem.classList.toggle('is_active');
        return;
      }

      /* Al abrir el drawer, asegurar que el panel activo no se vea vacío */
      if (event.target.closest('header-drawer summary')) {
        requestAnimationFrame(expandDefault);
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', expandDefault);
  } else {
    expandDefault();
  }
})();